module.exports = __webpack_public_path__ + "static/img/messenger-blue.0df06f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/social/messenger-blue.png
// module id = hqnv
// module chunks = 31